import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {ButtonAction} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import type {ButtonAppearance} from '@Components/button';
import {ButtonType, UPSELL_BUTTON_APPEARANCE} from '@Components/button';

export const BUTTON_GROUP_COMPONENT_TYPE = StreamComponentType.BUTTON_GROUP;

export const MAX_BUTTONS = 3;

export enum ButtonStyle {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PREMIUM = 'premium',
}

export const BUTTON_APPEARANCE_BY_STYLE: Record<ButtonStyle, ButtonAppearance> = {
  [ButtonStyle.PRIMARY]: {type: ButtonType.PRIMARY},
  [ButtonStyle.SECONDARY]: {type: ButtonType.SECONDARY},
  [ButtonStyle.PREMIUM]: UPSELL_BUTTON_APPEARANCE,
};

export interface ButtonSpec {
  label: string;
  action: ButtonAction;
  icon?: string;
  style?: ButtonStyle;
}

export interface ButtonGroupProps {
  buttons: ButtonSpec[];
}

export type ButtonGroupComponentPart = BaseComponentPart<StreamComponentType.BUTTON_GROUP, ButtonGroupProps>;
